import { render, staticRenderFns } from "./GlobalDrawer.vue?vue&type=template&id=4b7c56a0&scoped=true&"
import script from "./GlobalDrawer.vue?vue&type=script&lang=js&"
export * from "./GlobalDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7c56a0",
  null
  
)

export default component.exports